/**
 * locale-image-filter.js
 * The Oh Collective — Product Gallery Locale Filter
 *
 * Hides product images that are tagged for a different locale.
 * Convention: ALT text = "~*~Language~*~en---" (English) or "~*~Language~*~nl---" (Dutch)
 * Images without the marker are shown to all locales.
 *
 * HOW TO INSTALL:
 *   1. Upload this file to Shopify Admin → Content → Files (or Theme → Assets)
 *   2. Add the two-line snippet from theme-liquid-snippet.txt into your theme.liquid <head>
 */

(function () {
  'use strict';

  var MARKER = '~*~Language~*~';

  // ─── Detect current locale ───────────────────────────────────────────────────
  function getLocale() {
    // Shopify exposes this globally on storefronts
    if (window.Shopify && window.Shopify.locale) {
      return window.Shopify.locale.split('-')[0].toLowerCase();
    }
    // Fallback: read from URL path (e.g. /nl/products/... or /en/products/...)
    var match = window.location.pathname.match(/^\/([a-z]{2})(?:\/|-|$)/i);
    return match ? match[1].toLowerCase() : 'en';
  }

  // ─── Should this image be visible? ───────────────────────────────────────────
  function isVisibleForLocale(altText, locale) {
    var alt = (altText || '').trim();
    if (!alt.includes(MARKER)) return true;          // neutral — show always
    return alt.includes(MARKER + locale);            // matches this locale
  }

  // ─── Core filter ─────────────────────────────────────────────────────────────
  function filter() {
    var locale = getLocale();

    // Covers: Dawn theme main slider, older Debut theme, custom themes
    var selectors = [
      '.product__media-list > li',
      '.thumbnail-list > li',
      '.product-single__photos .product-single__photo-wrapper',
      '.product__media-wrapper .slider__slide'
    ];

    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (item) {
        var img = item.querySelector('img');
        if (!img) return;
        var show = isVisibleForLocale(img.alt, locale);
        item.style.display = show ? '' : 'none';
        // Also mark the item so CSS can target it (no-flash approach)
        item.setAttribute('data-locale-visible', show ? 'true' : 'false');
      });
    });

    // Reset gallery scroll to the first visible slide (desktop + mobile)
    document.querySelectorAll('.product__media-list, .product-single__photos').forEach(function (gallery) {
      if (gallery.scrollTo) {
        gallery.scrollTo({ left: 0, behavior: 'instant' });
      }
    });

    // Sync the slider counter if the theme exposes a slider component
    syncCounter();
  }

  // ─── Fix the "1 / of N" counter ──────────────────────────────────────────────
  function syncCounter() {
    // Dawn theme: slider-component custom element
    var sliderEl = document.querySelector('slider-component');
    if (sliderEl) {
      // Trigger the component's internal page update
      var firstSlide = sliderEl.querySelector('.slider__slide:not([style*="display: none"])');
      if (firstSlide && typeof sliderEl.onButtonClick === 'function') {
        // noop – just recalculate
      }
      // Update the total counter text
      var total = sliderEl.querySelector('.slider__counter--total');
      var current = sliderEl.querySelector('.slider__counter--current');
      if (total) {
        var visible = sliderEl.querySelectorAll('.slider__slide:not([style*="display: none"])').length;
        total.textContent = visible;
      }
      if (current) {
        current.textContent = '1';
      }
    }
  }

  // ─── Run strategy: early + deferred for reliability ──────────────────────────

  // 1. Run immediately if DOM already exists (handles cached pages, SPAs)
  if (document.readyState !== 'loading') {
    filter();
  }

  // 2. Run on DOMContentLoaded (standard case — before images fully load)
  document.addEventListener('DOMContentLoaded', filter);

  // 3. Run after short delays to catch async gallery init (common in themes)
  setTimeout(filter, 150);
  setTimeout(filter, 600);

  // 4. Re-run when Shopify re-renders a section (theme editor live preview)
  document.addEventListener('shopify:section:load', filter);

  // 5. Watch for dynamic DOM changes — handles mobile gallery lazy init
  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      var affected = mutations.some(function (m) {
        var t = m.target;
        return (
          (t.classList && (
            t.classList.contains('product__media-list') ||
            t.classList.contains('thumbnail-list') ||
            t.classList.contains('product__media-item')
          )) ||
          Array.from(m.addedNodes).some(function (n) {
            return n.nodeType === 1 && (
              n.classList.contains('product__media-item') ||
              n.classList.contains('slider__slide') ||
              n.querySelector && n.querySelector('.product__media-list')
            );
          })
        );
      });
      if (affected) filter();
    });

    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  // Expose publicly in case you need to trigger manually
  window.LocaleImageFilter = { run: filter, getLocale: getLocale };

})();
